import { Typography } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import styled, { css } from "styled-components";

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;

    svg {
      color: ${theme.colors.primary};
      width: 1rem;
      height: 1rem;

      margin-right: 0.56rem;
    }

    .MuiTypography-body1 {
      font-family: Poppins, sans-serif;
    }
  `}
`;

export const Link = styled(RouterLink)`
  color: inherit;

  &:hover {
    text-decoration: underline;
  }
`;

export const CurrentPage = styled(Typography)`
  ${({ theme }) => css`
    color: ${theme.colors.primary};
  `}
`;
